// Loader.js
import React from 'react';
import './chatLoaderstyles.less';

const Loader = () => {
    return (
        <div className="loader-container">
            <div className="loader">
                <div></div>
            </div>
            {/* <div className="loader">
                <div></div>
            </div>
            <div className="loader">
                <div></div>
            </div> */}
        </div>
    );
};

export default Loader;
